const events = ['fileProgress', 'fileSuccess', 'fileComplete', 'fileError'];

export default events;
